<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
          <Transition class="transition thing">
            <video-background 
              playbackRate=0.2
              :src="src"
              :poster="poster"
        
              overlay="linear-gradient(to bottom, #003, transparent)" 
              :class="`thing playercss`"
              :style="`height: 556px;`" v-show="pvisvideo === true">
            </video-background>
          </Transition>
          <div id="panorama" class="thing  gradient" v-show="pvisvideo === false && pictureimage === false">
          </div>
          <div v-show="pictureimage === true">
            <img :src="poster" style="height: 90%; width: 100%">
          </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext"></h1>
        </div>
      </main>
    </section>

    <div class="opscss">
      <OpsProd :opsproducts="opsproducts" />
    </div>
  </div>

  <section class="piccardsection mozpicsection @-moz-document url-prefix()">
    <div class="container cardslist mycardtxt @-moz-document url-prefix()" style="width: 100%;">
      <div class="row">
        <div class="col col-sm-12 col-sm-12 col-md-6 cardleftcol mycardtxt @-moz-document url-prefix()">
          <div v-html="oppgproddesc" class="prodinfodesc"></div>
        </div>
        <div class="col-sm-12 col-sm-12 col-md-6 cardrightcol mycardtxt @-moz-document url-prefix()">
          <PiclistCards :productlistcards="opsproductscards" cardlistcsstheme="cardlistcss" />
        </div>
      </div>
    </div>
  </section>
  
  <section class="chartsection mycardtxt @-moz-document url-prefix()">
    <div class="container chartgrp ">
      
      <div class="flex-container chartbox  ">
        <div class="silverchartmaintxt"><b>{{opgraphtoptitle}}</b></div>
        <div class="flex-item chart1">
          <div v-html="opsleftgraphtitle" class="maintxt"></div>
          <canvas id="myChart" class="@-moz-document url-prefix()"></canvas>
        </div>

        <div class="flex-item charttext1 formatbottom @-moz-document url-prefix()">
            <p class=""><small class="chartgeneral" v-html="opleftsupplytext"></small></p>
        </div>

        <div class="flex-item chart1 chart2">
          <div v-html="opsrightgraphtitle" class="maintxt maintxt1"></div>
          <canvas id="myChart1" class="@-moz-document url-prefix()"></canvas>
        </div>

        <div class="flex-item charttext2 formatbottom1 @-moz-document url-prefix()">
            <p class=""><small class="chartgeneral" v-html="oprightsupplytext"></small></p>
        </div>
      </div>
    </div>
  </section>

  <section class="lastdiv @-moz-document url-prefix()">
    <div class="threecarddiv">
      <ThreecardsSection :allcardsdata="contdata" />
    </div>


    <div class="container bottomtextdiv">
      <p v-html="opovbottomtext"></p>
    </div>
  </section>

 

<FooterPage />
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import OpsProd from '@/components/OpsProd.vue';
import PiclistCards from '@/components/PiclistCards.vue';
import ThreecardsSection from '@/components/ThreecardsSection.vue';
import Chart from 'chart.js/auto';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, OpsProd, PiclistCards, Chart, ThreecardsSection
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  cvdesc: '',
  valuesphotos: [],
  valuesphotosabout: [],
  cvpurposevaluelinkname: '',
  cvlink: '',
  pictureimage: '',

  //General inputs
  oppgdesc: '',
  oppgproddesc: '',
  opgraphtoptitle: '',
  opsleftgraphtitle: '',
  opleftsupplytext: '',
  opsrightgraphtitle: '',
  oprightsupplytext: '',
  opprodinfo: '',
  investtext: '',
  investimg: '',
  investlinktext: '',
  investlink: '',
  prodtext: '',
  prodimg: '',
  prodlinktext: '',
  prodlink: '',
  lcarbontext: '',
  lcarbonimg: '',
  lcarbonlinktext: '',
  lcarbonlink: '',
  opovbottomtext: '',
  strbuild: '',

  //ops products declarations
  opsproducts: [],
  opsproductscards: [],
  opssilverdemandgraphlabels: [],
  opssilverdemandgraphdata: [],
  opssilversupplygraphlabels: [],
  opssilversupplygraphdata: [],

  contdata: [],

  showImage: false,
  publicPath: window.location.origin,

  myPicUrl: '',

  cvvisibility: true,

  height: 0,
  width: 0,
 
  }
},
methods: {
  async logChange(event) {
    this.showImage = true
    this.histsearchid = event
  //------------Homepage Stock Prices---------------
  await axios.get(`gethistorydataid/${this.histsearchid}`).then(
      response => {
          this.yearimages = response.data
    })
    .catch((error) => {
        console.log(error)
      })
},
resizeHandler() {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
  }
},

created() {
    window.addEventListener("resize", this.resizeHandler);
},

destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
},

async mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath

  this.height = window.innerHeight;
  this.width = window.innerWidth;

 await axios.get('allpagespv/products').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  
  
  //------------Operations General product page info ---------------
  await axios.get('getopsproductgeneral/').then(
    response => {
    this.oppgdesc = response.data.oppgdesc
    this.oppgproddesc = response.data.oppgproddesc
    this.opgraphtoptitle = response.data.opsproductspgraphtoptitle
    this.opsleftgraphtitle = response.data.opsleftgraphtitle
    this.opleftsupplytext = response.data.opleftsupplytext
    this.opsrightgraphtitle = response.data.opsrightgraphtitle
    this.oprightsupplytext = response.data.oprightsupplytext
    this.opprodinfo = response.data.opprodinfo
    this.investtext = response.data.investtext
    this.investimg = this.myPicUrl + response.data.investimg
    this.investlinktext = response.data.investlinktext
    this.investlink = response.data.investlink
    this.prodtext = response.data.prodtext
    this.prodimg = response.data.prodimg
    this.prodlinktext = response.data.prodlinktext
    this.prodlink = response.data.prodlink
    this.lcarbontext = response.data.lcarbontext
    this.lcarbonimg = response.data.lcarbonimg
    this.lcarbonlinktext = response.data.lcarbonlinktext
    this.lcarbonlink = response.data.lcarbonlink
    this.opovbottomtext = response.data.opovbottomtext
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page products ---------------
  await axios.get('getopspageproducts/').then(
    response => {
    this.opsproducts = response.data
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page Cards ---------------
   await axios.get('valuesphotos1/products').then(
    response => { 
    this.opsproductscards = response.data
  })
  .catch((error) => {
      console.log(error)
    }) 

  //------------Container Section---------------
  axios.get('getallcardsectionsdata/products').then(
    response => {
        this.contdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //------------Operations products page Cards ---------------
   await axios.get('getsilverdemandgraphdata/products').then(
    response => { 
      this.opssilverdemandgraphlabels = response.data.glabels
      this.opssilverdemandgraphdata = response.data.gdata
    const ctx = document.getElementById('myChart');
    const myChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: this.opssilverdemandgraphlabels,
        datasets: [{
            label: '# of Votes',
            data: this.opssilverdemandgraphdata,
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)'
            // 'rgba(153, 102, 255, 0.2)',
            // 'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'
            // 'rgba(153, 102, 255, 1)',
            // 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            hoverOffset: 24,
            responsive: true,
            maintainAspectRatio: true,
            resizeDelay:  0
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      responsive: true,
      // layout: {
      //       padding: 30
      //   },
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart;
  })
  .catch((error) => {
      console.log(error)
    })   

  //------------Operations products page Cards ---------------
   await axios.get('getsilversupplygraphdata/products').then(
    response => { 
    this.opssilversupplygraphlabels = response.data.rlabels
    this.opssilversupplygraphdata = response.data.rdata

    const ctx = document.getElementById('myChart1');
    const myChart1 = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: this.opssilversupplygraphlabels,
        datasets: [{
            label: '# of Votes',
            data: this.opssilversupplygraphdata,
            backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)'
            // 'rgba(153, 102, 255, 0.2)',
            // 'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)'
            // 'rgba(153, 102, 255, 1)',
            // 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            hoverOffset: 24,
            responsive: true,
            // maintainAspectRatio: true,
            resizeDelay: 0
            // radius: 100,
            
        }]
    },
    options: {
      animation:{
        animateRotate: true
      },
      // layout: {
      //       padding: 30
      //   },
      responsive: true,
      // aspectRatio: 1.4,
      plugins: {
        legend: {
          display: true,
            position: "bottom",
            align: "center"
          }
        }
    }
    });
    myChart1;
 
  })
  .catch((error) => {
      console.log(error)
    }) 
},

}

</script>

<style scoped>
.section03 {
  height: 300px;
}
.piccardsection {
  margin-top: -80px;
}

.chartsection {
  margin-top: -300px;
}

.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.opscss {
  margin-top: 400px;
}

.txtdata {
  text-align: left;
  background-color: #003;;
  margin-left: 0px;
  width: 500px;
  margin-top: -100px;
  opacity: 0.7;
 }
 .prodinfodesc {
  margin-top: 80px;
  text-align: left;
  padding-right: 30px;
 }
 .chartcss {
  width: 100%;
 }


 .chartsection {
  background-color: whitesmoke;
  
 }
.maintxt {
  color: #003;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.silverchartmaintxt {
  width: 100%;
  margin: 0 auto;
  padding-top: 50px;
  font-size: 20px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #003;
}

.bottomtextdiv {
  height: 200px;
  margin-top: 100px;
  margin-bottom: 100px;
}
/* Move the background and make it larger. 
/* Media Query CSS*/

 /*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .txtdata {
    width: 400px;
    margin-top: -400px;
   }
   .opscss {
    margin-top: 550px;
   }
  
   .myCharts {
    width: 100%; 
    height: 70%; 
    margin-top: 50px;
   }
   .chartsection {
    margin-top: 1800px;
    padding-bottom: 200px;
    margin-bottom: -400px;
   }
 
   .cardlistcss {
    margin-top: 200px;
   }
   
  .cardslist {
    padding-bottom: 20px;
  }

  .chartgeneral {
    width: 100%;
  }

  .piccardsection {
    margin-top: 350px;
    margin-bottom: -120px;
   }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    height: 650px;
    /* Then we define how is distributed the remaining space */
  }

  .chartgeneral {
    font-size: 18px;
    font-weight: bold;
    color: #003;
  }
  
  .flex-item {
    padding: 5px;
    width: 70%;
    height: 70%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .card-img-top {
    width: 70%;
  }
  .flextextcss {
    margin-top: -80px;
    color: #003;
    font-size: 14px;
  }
 
   .cardleftcol {
    margin-top: 300px;
   }

   .chartgrp {
    margin-bottom: 900px;
   }
   
  

   .chart2 {
    margin-top: -800px;
   }
   .chart2{
    margin-top: -280px;
   }
  
  
 

  @-moz-document url-prefix() { 
  .mycardtxt {
    margin-top: 700px;
  }
  .cardslist {
    margin-top: -650px;
  }
  .chartsection {
    margin-top: 2550px;
    padding-bottom: 200px;
    margin-bottom: -400px;
   }

  .piccardsection {
  margin-top: 440px;

    }
    
  .cardrightcol {
  margin-top: 10px;
     }

     .chart2{
      margin-top: -400px;
     }
      
  .flex-item {
    padding: 5px;
    width: 80%;
    height: 80%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }

  .cardleftcol {
    margin-top: 1000px;
   }
  .maintxt1{
    margin-top: -400px;
  }

  .formatbottom1 {
    margin-top: -400px;
  }
  .lastdiv {
    margin-top: 100px;
  }
  }
  
 }


 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .txtdata {
    width: 400px;
    margin-top: -400px;
   }
   .opscss {
    margin-top: 550px;
   }
  
   .myCharts {
    width: 100%; 
    height: 70%; 
    margin-top: 50px;
   }
   .chartsection {
    margin-top: 880px;
    padding-bottom: 200px;
    margin-bottom: -400px;
   }
 
   .cardlistcss {
    margin-top: 200px;
   }
   
  .cardslist {
    padding-bottom: 20px;
  }

  .chartgeneral {
    width: 100%;
  }

  .piccardsection {
    margin-top: 1000px;
   }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    height: 650px;
    /* Then we define how is distributed the remaining space */
  }

  .chartgeneral {
    font-size: 18px;
    font-weight: bold;
    color: #003;
  }
  
  .flex-item {
    padding: 5px;
    width: 70%;
    height: 70%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .card-img-top {
    width: 70%;
  }
  .flextextcss {
    margin-top: -80px;
    color: #003;
    font-size: 14px;
  }
 
   .cardleftcol {
    margin-top: -600px;
   }

   .chartgrp {
    margin-bottom: 900px;
   }
   
  

   .chart2 {
    margin-top: -800px;
   }
   .chart2{
    margin-top: -280px;
   }
  
  
 

  @-moz-document url-prefix() { 
  .mycardtxt {
    margin-top: 700px;
  }
  .cardslist {
    margin-top: -650px;
  }
  .chartsection {
    margin-top: 2500px;
    padding-bottom: 200px;
    margin-bottom: -400px;
   }

  .piccardsection {
  margin-top: 440px;

    }

     .chart2{
      margin-top: -400px;
     }
      
  .flex-item {
    padding: 5px;
    width: 80%;
    height: 80%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }

  .cardleftcol {
    margin-top: 800px;
   }
  
  .cardrightcol {
    margin-top: 10px;
       }
  .maintxt1{
    margin-top: -400px;
  }
  .formatbottom1 {
    margin-top: -400px;
  }
  .lastdiv {
    margin-top: 100px;
  }
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .txtdata {
    width: 400px;
    margin-top: -400px;
   }
   .opscss {
    margin-top: 550px;
   }
  
   .myCharts {
    width: 100%; 
    height: 70%; 
    margin-top: 50px;
   }
   .chartsection {
    margin-top: 300px;
    padding-bottom: 100px;
    margin-bottom: -800px;
    height: auto;
   }
 
   .cardlistcss {
    margin-top: 200px;
   }
   
  .cardslist {
    padding-bottom: 20px;
  }

  .chartgeneral {
    width: 100%;
  }

  .piccardsection {
    margin-top: 250px;
    margin-bottom: -200px;
   }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    height: 650px;
    /* Then we define how is distributed the remaining space */
  }

  .chartgeneral {
    font-size: 18px;
    font-weight: bold;
    color: #003;
  }
  
  .flex-item {
    padding: 5px;
    width: 50%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .card-img-top {
    width: 70%;
  }
  .flextextcss {
    margin-top: -80px;
    color: #003;
    font-size: 14px;
  }
 
  .cardleftcol {
    margin-top: 160px;
   }

  .cardrightcol {
    margin-top: 260px;
   }

  .chartgrp {
  margin-bottom: 900px;
  }

  .maintxt1 {
    margin-top: 100px;
  }
   
   .chart1{
      margin-top: 20px;
   }

   .chart2 {
    margin-top: 10px;
   }

   .formatbottom{
    margin-bottom: -400px;
   }
   .charttext1 {
    margin: 0 auto;
    padding-top: 200px;
   }
   .charttext2 {
    margin: 0 auto;
    padding-top: 300px;
   }
   .lastdiv{
    background-color: white;
    margin-bottom: 200px;
    width: auto;
   }
  
 

@-moz-document url-prefix() { 
  .mycardtxt {
    margin-top: 700px;
  }
  .cardslist {
    margin-top: -650px;
  }
  .chartsection {
    margin-top: 1200px;

    }

  .charttext1 {
    margin: 0 auto;
    padding-top: 1200px;
    }
    .charttext2 {
    margin: 0 auto;
    margin-top: 300px;
    }

  .cardrightcol {
  margin-top: 10px;
     }
      
  .flex-item {
    padding: 5px;
    width: 50%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .cardleftcol {
    margin-top:900px;
   }

  .cardrightcol {
    margin-top: 1000px;
   }

  .formatbottom{
    margin-top: 250px;
  }
  .chart2{
    margin-top: -200px;
  }
  }

 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .txtdata {
    width: 500px;
    margin-top: -200px;
   }
   .opscss {
    margin-top: 400px;
   }
  
   .myCharts {
    width: 100%; 
    height: 70%; 
    margin-top: 50px;
   }
   .chartsection {
    margin-top: 300px;
    padding-bottom: 100px;
    height: 1000px;
   }

   .lastdiv {
    margin-top: 1000px;
   }
 
   .cardlistcss {
    margin-top: 200px;
   }
   
  .cardslist {
    padding-bottom: 20px;
  }

  .chartgeneral {
    width: 100%;
  }

  .mozpicsection {
    margin-top: -300px;
    margin-bottom: -200px;
   }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    height: 650px;
    /* Then we define how is distributed the remaining space */
  }

  .chartgeneral {
    font-size: 18px;
    font-weight: bold;
    color: #003;
  }
  
  .flex-item {
    padding: 5px;
    width: 50%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .card-img-top {
    width: 50%;
  }
  .flextextcss {
    margin-top: -80px;
    color: #003;
    font-size: 14px;
  }
 
  .cardleftcol {
    margin-top: 160px;
   }

  .cardrightcol {
    margin-top: 260px;
   }

  .chartgrp {
  margin-bottom: 900px;
  }

  .maintxt1 {
    margin-top: 100px;
  }
   
   .chart1{
      margin-top: 20px;
   }

   .chart2 {
    margin-top: 100px;
   }

   .formatbottom{
    margin-bottom: -400px;
   }
   .charttext1 {
    margin: 0 auto;
    padding-top: 200px;
   }
   .charttext2 {
    margin: 0 auto;
    padding-top: 300px;
   }
   .lastdiv{
    background-color: white;
    margin-bottom: 200px;
    width: auto;
   }

   .maintxt {
    margin-top: -40px;
   }
   .maintxt1 {
    margin-top: -40px;
   }
   .bottomtextdiv{
    margin-bottom: -200px;
   }
  

@-moz-document url-prefix() { 
  .mycardtxt {
    margin-top: 700px;
  }
  .cardslist {
    margin-top: -650px;
  }
  .chartsection {
    margin-top: 1200px;

    }

  .mozpicsection {
      margin-top: -900px;
      margin-bottom: -200px;
     }
  

  .lastdiv {
    margin-top: 1000px;
    }

  .charttext1 {
    margin: 0 auto;
    padding-top: 1200px;
    }

.charttext2 {
  margin: 0 auto;
  margin-top: 300px;
  }

  .cardrightcol {
  margin-top: 10px;
     }
      
  .flex-item {
    padding: 5px;
    width: 50%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .cardleftcol {
    margin-top:900px;
   }

  .cardrightcol {
    margin-top: 1000px;
   }

  .formatbottom{
    margin-top: 250px;
  }
  .chart2{
    margin-top: -200px;
  }
  .bottomtextdiv{
    margin-bottom: -400px;
   }

  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .txtdata {
    width: 500px;
    margin-top: -100px;
   }
   .opscss {
    margin-top: 500px;
   }
  
   .myCharts {
    width: 100%; 
    height: 70%; 
    margin-top: 50px;
   }
   .chartsection {
    margin-top: 300px;
    padding-bottom: 100px;
    height: 600px;
   }

   .lastdiv {
    margin-top: 1000px;
   }
 
   .cardlistcss {
    margin-top: 200px;
   }
   
  .cardslist {
    padding-bottom: 20px;
  }

  .chartgeneral {
    width: 100%;
  }

  .mozpicsection {
    margin-top: -300px;
    margin-bottom: -200px;
   }

  .flex-container {
    display: flex;
    flex-flow: row wrap;
    height: 650px;
    /* Then we define how is distributed the remaining space */
  }

  .chartgeneral {
    font-size: 18px;
    font-weight: bold;
    color: #003;
  }
  
  .flex-item {
    padding: 5px;
    width: 25%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .card-img-top {
    width: 50%;
  }
  .flextextcss {
    margin-top: -80px;
    color: #003;
    font-size: 14px;
  }
 
  .cardleftcol {
    margin-top: 160px;
   }

  .cardrightcol {
    margin-top: 260px;
   }

  .chartgrp {
  margin-bottom: 900px;
  }

  .chart1{
    margin-top: -80px;
  }

  .chart2 {
  margin-top: -80px;
  }


.lastdiv{
  background-color: white;
  margin-bottom: 200px;
  width: auto;
  }
  .charttext1 {
    margin-top: 180px;
  }

  .charttext2 {
    margin-top: 180px;
  }
  
 

@-moz-document url-prefix() { 
  .mycardtxt {
    margin-top: 700px;
  }

  .chartbox {
    margin-top: 10px;
  }

  .silverchartmaintxt {
    margin-bottom: -50px;
  }
  
  .txtdata {
    width: 500px;
    margin-top: -100px;
   }
   .opscss {
    margin-top: 400px;
   }

  .cardslist {
    margin-top: -650px;
  }
  .chartsection {
    margin-top: 1200px;

    }

  .mozpicsection {
      margin-top: -900px;
      margin-bottom: -200px;
     }
  

  .lastdiv {
    margin-bottom: 400px;
    }

  .charttext1 {
    margin: 0 auto;
    padding-top: 1200px;
    }



  .cardrightcol {
  margin-top: 10px;
     }
      
  .flex-item {
    padding: 5px;
    width: 25%;
    height: 50%;
    
    line-height: 150px;
    color: white;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
  }
  .cardleftcol {
    margin-top:900px;
   }

  .cardrightcol {
    margin-top: 1000px;
   }

  .formatbottom{
    margin-top: 250px;
  }

  .formatbottom1{
    margin-top: 250px;
  }
  .chart1{
    margin-top: 20px;
  }

  .chart2 {
  margin-top: 20px;
  }
  }
 } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
    .charttext1 {
      margin-top: 180px;
    }

    .charttext2 {
      margin-top: 180px;
    }
  }
</style>
